{
  "manager": {
    "couponRowDetails": {
      "noPromotionCodes": "No promotion codes for this coupon.",
      "archived": "Archived",
      "expired": "Expired",
      "active": "Active",
      "expires": "Expires",
      "maxRedemptions": "Max Redemptions",
      "unlimited": "Unlimited",
      "appliesTo": "Applies To",
      "memberships": "Memberships",
      "allPlans": "All plans",
      "plan": "plan",
      "plans": "plans",
      "programs": "Programs",
      "allPrograms": "All programs",
      "program": "program",
      "programsPlural": "programs",
      "never": "Never"
    },
    "discountCodesCreate": {
      "createDiscountCode": "Create Discount Code",
      "discountDetails": "Discount Details",
      "nameLabel": "Name *",
      "thisFieldIsRequired": "This field is required",
      "namePlaceholder": "e.g. Summer Promotion",
      "discountTypeLabel": "Discount Type *",
      "selectADiscountType": "--- Select a Discount Type ---",
      "percentage": "Percentage",
      "fixedAmount": "Fixed Amount",
      "percentOffLabel": "Percent Off *",
      "percentOffRange": "Must be between 0.01 and 100",
      "percentOffPlaceholder": "e.g. 10",
      "amountOffLabel": "Amount Off *",
      "amountOffMin": "Must be at least 0.01",
      "amountOffPlaceholder": "e.g. 5.00",
      "discountCodes": "Discount Codes",
      "discountCodesHelp": "Add one or more discount codes. Each code has its own usage limits and plan selection.",
      "codeNumber": "Code {number}",
      "plan": "plan",
      "program": "program",
      "maxBadge": "Max",
      "expiresBadge": "Expires",
      "removeCode": "Remove code",
      "codeNameLabel": "Code Name *",
      "codeNameDescription": "This is the code customers will enter at checkout. Only characters A-Z 0-9",
      "codeNamePlaceholder": "e.g. SUMMER50OFF",
      "maxRedemptions": "Max Redemptions",
      "maxRedemptionsDescription": "Leave blank for unlimited",
      "unlimited": "Unlimited",
      "expirationDate": "Expiration Date",
      "membershipPlans": "Membership Plans",
      "applyToAllMembershipPlans": "Apply to all membership plans",
      "includesAnyPlansInFuture": "Includes any plans created in the future.",
      "deselectAll": "Deselect all",
      "selectAll": "Select all",
      "programs": "Programs",
      "applyToAllPrograms": "Apply to all programs",
      "includesAnyProgramsInFuture": "Includes any programs created in the future.",
      "atLeastOneTarget": "At least one membership plan or program must be selected.",
      "addAnotherCode": "Add Another Code",
      "atLeastOnePromoCode": "At least one promotion code is required.",
      "summary": "Summary",
      "discountLabel": "Discount:",
      "codeLabel": "Code:",
      "plansLabel": "Plans:",
      "allMemberships": "All memberships",
      "selected": "selected",
      "programsLabel": "Programs:",
      "allPrograms": "All programs",
      "maxRedemptionsLabel": "Max Redemptions:",
      "expiresLabel": "Expires:",
      "percentOffSummary": "{percent}% off",
      "amountOffSummary": "{amount} off",
      "notSet": "Not set",
      "discountCodeCreated": "Discount code created!",
      "somethingWentWrong": "Something went wrong creating the code.",
      "failedToLoad": "Failed to load membership types and programs.",
      "pluralSuffix": "s"
    },
    "discountCodesEdit": {
      "editHeading": "Edit: {name}",
      "editDiscountCode": "Edit Discount Code",
      "couponDetails": "Coupon Details",
      "nameLabel": "Name *",
      "thisFieldRequired": "This field is required",
      "namePlaceholder": "e.g. Summer Promotion",
      "discountLabel": "Discount:",
      "percentOff": "{percent}% off",
      "amountOff": "{amount} off",
      "durationLabel": "Duration:",
      "durationOnce": "Once",
      "durationForever": "Forever",
      "durationMonths": "{months} months",
      "discountSettingsLocked": "Discount settings cannot be changed after creation.",
      "existingPromotionCodes": "Existing Promotion Codes",
      "archived": "Archived",
      "noPromotionCodesYet": "No promotion codes yet.",
      "addNewPromotionCodes": "Add New Promotion Codes",
      "addCodesHelp": "Add one or more new codes to this coupon.",
      "codeFallback": "Code {number}",
      "max": "Max",
      "expires": "Expires",
      "removeCode": "Remove code",
      "codeNameLabel": "Code Name *",
      "codeNameDescription": "This is the code customers will enter at checkout. Only characters A-Z 0-9",
      "codePlaceholder": "e.g. SUMMER50OFF",
      "maxRedemptionsLabel": "Max Redemptions",
      "leaveBlankUnlimited": "Leave blank for unlimited",
      "unlimitedPlaceholder": "Unlimited",
      "expirationDateLabel": "Expiration Date",
      "membershipPlans": "Membership Plans",
      "applyAllMemberships": "Apply to all membership plans",
      "includesPlansFuture": "Includes any plans created in the future.",
      "deselectAll": "Deselect all",
      "selectAll": "Select all",
      "programs": "Programs",
      "applyAllPrograms": "Apply to all programs",
      "includesProgramsFuture": "Includes any programs created in the future.",
      "atLeastOneTarget": "At least one membership plan or program must be selected.",
      "addACode": "Add a Code",
      "noChangesToSave": "No changes to save.",
      "discountCodeUpdated": "Discount code updated!",
      "somethingWentWrong": "Something went wrong saving the changes.",
      "failedToLoadCoupon": "Failed to load coupon details.",
      "plan": "plan",
      "program": "program",
      "pluralSuffix": "s"
    },
    "discountCodesIndex": {
      "title": "Discount Codes",
      "percentOff": "{percent}% off",
      "amountOff": "{'$'}{amount} off",
      "memberships": "Memberships",
      "programs": "Programs",
      "moreCount": "+{count} more",
      "none": "None",
      "active": "Active",
      "archived": "Archived"
    },
    "discountCodesShow": {
      "discountCode": "Discount Code",
      "archive": "Archive",
      "promotionCodes": "Promotion Codes",
      "totalRedemptions": "Total Redemptions",
      "totalRevenue": "Total Revenue",
      "couponDetails": "Coupon Details",
      "status": "Status",
      "active": "Active",
      "archived": "Archived",
      "transactions": "Transactions",
      "archiveConfirmPrefix": "Are you sure you would like to archive",
      "thisCoupon": "this coupon",
      "archiveConfirmSuffix": "? This will also archive all associated promotion codes.",
      "name": "Name",
      "discount": "Discount",
      "created": "Created"
    },
    "promotionCodeEdit": {
      "editName": "Edit: {name}",
      "editPromotionCode": "Edit Promotion Code",
      "targeting": "Targeting",
      "targetingHelp": "Choose which membership plans and programs this code applies to. Other code details (name, expiration, redemption limit) are not editable.",
      "membershipPlans": "Membership Plans",
      "applyToAllMembershipPlans": "Apply to all membership plans",
      "includesFuturePlans": "Includes any plans created in the future.",
      "deselectAll": "Deselect all",
      "selectAll": "Select all",
      "programs": "Programs",
      "applyToAllPrograms": "Apply to all programs",
      "includesFuturePrograms": "Includes any programs created in the future.",
      "targetRequired": "At least one membership plan or program must be selected.",
      "promotionCodeUpdated": "Promotion code updated!",
      "saveFailed": "Something went wrong saving the changes.",
      "archivedCannotEdit": "Archived promotion codes cannot be edited.",
      "loadFailed": "Failed to load promotion code."
    },
    "promotionCodeShow": {
      "promotionCode": "Promotion Code",
      "archive": "Archive",
      "redemptions": "Redemptions",
      "totalRevenue": "Total Revenue",
      "maxRedemptions": "Max Redemptions",
      "unlimited": "Unlimited",
      "details": "Details",
      "status": "Status",
      "archived": "Archived",
      "expired": "Expired",
      "active": "Active",
      "memberships": "Memberships",
      "appliesToAllMembershipPlans": "Applies to all membership plans, including any created in the future.",
      "programs": "Programs",
      "appliesToAllPrograms": "Applies to all programs, including any created in the future.",
      "transactions": "Transactions",
      "archiveConfirm": "Are you sure you would like to archive",
      "thisPromotionCode": "this promotion code",
      "unarchiveConfirm": "Are you sure you would like to unarchive",
      "name": "Name",
      "expires": "Expires",
      "never": "Never",
      "appliesTo": "Applies To"
    }
  }
}
